import { ReactComponent as GazIcon } from '../../../assets/gas-meter.svg';
import { IndexItemResponse } from '../../../models/IndexItemResponse';
import MeterIndexDetailValueItemHead from './MeterIndexDetailValueItemHead';
import { ReactComponent as MoonIcon } from '../../../assets/moon.svg';
import { ReactComponent as MoonStarIcon } from '../../../assets/moon-star.svg';
import { NumberUtils } from '../../../common/numberUtils';
import { SDPDivisionEnum } from '../../../enum/SDPDivisionEnum';
import { ReactComponent as SunIcon } from '../../../assets/sun.svg';
import { VolumeItemResponse } from '../../../models/VolumeItemResponse';
import { VolumeTypeEnum } from '../../../enum/VolumeTypeEnum';
import { useTranslation } from 'react-i18next';

export interface MeterIndexDetailValueItemProps {
  index: IndexItemResponse;
  value?: VolumeItemResponse;
  division?: SDPDivisionEnum;
}
export default function MeterIndexDetailValueItem({
  index,
  value,
  division,
}: MeterIndexDetailValueItemProps) {
  const { t } = useTranslation();
  const isTh =
    index.type.includes(VolumeTypeEnum.CONSUMPTION_TH) ||
    index.type.includes(VolumeTypeEnum.INJECTION_TH);
  return (
    <div className="meter-index-detail__item__block col-12 col-md-4">
      <div className="meter-index-detail__item__wrapper">
        <div className="meter-index-detail__item__data">
          <div className="meter-index-detail__item__data__head">
            {isTh && (
              <MeterIndexDetailValueItemHead
                icon={
                  division === SDPDivisionEnum.GAS ? (
                    <GazIcon className="icon icon--small" />
                  ) : (
                    <SunIcon className="icon icon--small" />
                  )
                }
                value={value?.th}
                title={t('overview.meter.detail.index.detail.total.hour.index')}
              />
            )}

            {!isTh &&
              [VolumeTypeEnum.CONSUMPTION_DAY, VolumeTypeEnum.INJECTION_DAY].includes(
                index.type
              ) && (
                <MeterIndexDetailValueItemHead
                  icon={<SunIcon className="icon icon--small" />}
                  value={value?.day}
                  title={t('overview.meter.detail.index.detail.peak.meter.index')}
                />
              )}
            {!isTh &&
              [VolumeTypeEnum.CONSUMPTION_NIGHT, VolumeTypeEnum.INJECTION_NIGHT].includes(
                index.type
              ) && (
                <MeterIndexDetailValueItemHead
                  icon={<MoonIcon className="icon" />}
                  value={value?.night}
                  title={t('overview.meter.detail.index.detail.off.peak.index')}
                />
              )}
            {!isTh &&
              [
                VolumeTypeEnum.CONSUMPTION_EXCLUSIVE_NIGHT,
                VolumeTypeEnum.INJECTION_EXCLUSIVE_NIGHT,
              ].includes(index.type) && (
                <MeterIndexDetailValueItemHead
                  icon={<MoonStarIcon className="icon" />}
                  value={value?.exclusiveNight}
                  title={t('overview.meter.detail.index.detail.night.only.index')}
                />
              )}
          </div>
          <div className="meter-index-detail__item__data__value">
            <div className="meter-index-detail__item__data__value__item">
              <div className="meter-index-detail__item__data__value__item__title">
                {t('common.start')}
              </div>
              <div className="meter-index-detail__item__data__value__item__number">
                {NumberUtils.parse(index.startIndex, 2)}
                &nbsp;
                {SDPDivisionEnum.getUnit(division)}
              </div>
            </div>
            <div className="meter-index-detail__item__data__value__item">
              <div className="meter-index-detail__item__data__value__item__title">
                {t('common.end')}
              </div>
              <div className="meter-index-detail__item__data__value__item__number">
                {NumberUtils.parse(index.endIndex, 2)}
                &nbsp;
                {SDPDivisionEnum.getUnit(division)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
